import feedback from './feedback'

export default {
  name: 'Feedback',
  path: 'feedback',
  meta: {
    label: 'feedback',
    auth: 'feedback'
  },
  component: {
    name: 'Feedback',
    render(c) {
      return c('router-view')
    }
  },
  children: [feedback]
}
